<template>
	<section id="bejelentkezes">
		<!--gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"--><!--A v-img-ben-->
		<v-container class="fill-height px-4 py-12">
			<v-responsive
				class="d-flex align-center"
				height="100%"
				width="100%"
			>
	          <v-row align="center" justify="center">
							<v-col cols="12" sm="7">
		            <v-card class="elevation-12">
		              <v-tabs
		                v-model="aktivtab"
		                color="primary"
										icons-and-text>
		                <v-tab>
		                  Bejelentkezés
											<v-icon>fa-sign-in-alt</v-icon>
		                </v-tab>
		                <v-tab>
		                  Elfelejtett jelszó
											<v-icon>fa-key</v-icon>
		                </v-tab>
		                <v-tab-item>
		                  <v-card-text>
		                    <v-form>
		                      <v-text-field
		                        v-model="bejelentkezesmezo.email"
		                        label="Email"
		                        name="email"
		                        type="text"
														prepend-inner-icon="fa-envelope"
		                      ></v-text-field>

		                      <v-text-field
		                        v-model="bejelentkezesmezo.jelszo"
		                        label="Jelszó"
		                        name="jelszo"
		                        type="password"
														prepend-inner-icon="fa-key"
		                      ></v-text-field>
		                    </v-form>
		                  </v-card-text>
		                  <v-card-actions>
		                    <v-spacer></v-spacer>
		                    <v-btn color="primary" rounded @click="bejelentkezes()">Bejelentkezés<v-icon>fa-sign-in-alt</v-icon></v-btn>
		                  </v-card-actions>
		                </v-tab-item>
		                <v-tab-item>
		                  <v-card-text>
												<p>Az email címedre egy véletlenszerűen generált új jelszót fogsz kapni</p>
		                    <v-form>
		                      <v-text-field
		                        v-model="elfelejtettjelszo.email"
		                        label="Email"
		                        name="email"
		                        type="text"
														prepend-inner-icon="fa-envelope"
		                      ></v-text-field>
		                    </v-form>
		                  </v-card-text>
		                  <v-card-actions>
		                    <v-spacer></v-spacer>
		                    <v-btn color="primary" rounded v-if="elfelejtettjelszo.email" @click="ujjelszoigenylese()">Új jelszó igénylése<v-icon>fa-plus</v-icon></v-btn>
		                  </v-card-actions>
		                </v-tab-item>
		              </v-tabs>

		            </v-card>
							</v-col>
							<v-col cols="12" sm="5">
								<v-img
					        :src="`${$store.state.backendeleres}dynamic/logo.png`"
					      />
							</v-col>
						</v-row>
			      <v-snackbar
				      v-model="snackbar.megnyit"
				    >
				      {{ snackbar.szoveg }}
				      <v-btn
				        color="pink"
				        text
				        @click="snackbar.megnyit = false"
				      >
				        Bezár
				      </v-btn>
				    </v-snackbar>
				</v-responsive>
			</v-container>
  </section>
</template>
<script>
	 import router from "../router"

	export default {
data: function () {
  	return {
      aktivtab: 0,
      bejelentkezesmezo: {
        email:"",
        jelszo:""
      },
			elfelejtettjelszo: {
				email: ""
			},
  		snackbar:{
  			szoveg:"",
  			megnyit:false
  		}
  	}
  },
  methods: {
  	bejelentkezes: function(){this.axios.post(this.$store.state.backendeleres+"bejelentkezes", {email: this.bejelentkezesmezo.email, jelszo: this.bejelentkezesmezo.jelszo})
  		.then(response =>{
  			if(response.data.sikeresbejelentkezes){
      			this.$store.dispatch('bejelentkezesallasvaltas', true)
            this.axios.get(this.$store.state.backendeleres+"hitelesites/minosites").then((response) =>{
              this.$store.commit('minosites',response.data.minosites);
							this.$store.commit('diakJelolSzilenciumot',response.data.diakJelolSzilenciumot)
							this.$store.commit('diakJelolTermet',response.data.diakJelolTermet)

            })
						this.$store.commit('id',response.data.id)
  				router.push('/profil');
  			}
  			else{
  				this.snackbar.szoveg=response.data.hiba;
  				this.snackbar.megnyit=true;
  			}
  		});
  	},
		ujjelszoigenylese: function() {
			this.axios.post(this.$store.state.backendeleres+"elfelejtettjelszo",{email: this.elfelejtettjelszo.email})
								.then((response) => {
									if(response.data.ok){ this.aktivtab=0; this.bejelentkezesmezo.email=this.elfelejtettjelszo.email;this.elfelejtettjelszo.email=""}
									this.snackbar.szoveg = response.data.ok ? "Jelentkezz be az email címedre kapott új jelszóval." : ("Az új jelszó igénylése során hiba történt: "+response.data.hiba)
									this.snackbar.megnyit=true;
								})
		}
  },
  mounted () {
  	if(this.$store.bejelentkezve){
  		router.push('/');
  	}
  }
 }
</script>
